/* eslint-ignore */
// @ts-nocheck
import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ includeMarginTop }) => includeMarginTop && css`
    margin-top: ${includeMarginTop}px;
  `}
`;

export const Content = styled.label`
  cursor: pointer;
  font-size: 22px;

  position: relative;
  height: 18px;
  width: 18px;
  background-color: #ffff;
  border: 2px solid #7a7a7a;
  border-radius: 4px;

  ${({ isChecked }) =>
    isChecked &&
    css`
      background-color: #0000ff;
      border: 2px solid #0000ff;
    `}

  svg {
    position: absolute;
    top: 0px;
    left: 0px;
    color: #ffff;
    stroke-width: 1.5;
  }
`;

export const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

export const Span = styled.span``;